module.exports = "https://cdn.dove.it/_next/static/public/assets/services/videochiamata.dfcce0fbb588d7518160ee6f36f08a30.jpg";